module.exports = __webpack_public_path__ + "img/Kalsiy_Forte_Gray_1280x1010.9b6f8dda.jpg";